// import React, { useEffect, useState, useRef } from "react";
// import { useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { checkQRStatus, redeemQr, sendOTP, getConsumerDetails } from "../../redux/actions/consumerActions";
// import { LoadScriptNext, Autocomplete } from "@react-google-maps/api";
// import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// import logo from "../../assets/logo/shubam.png";
// import scannwin from "../../assets/logo/scannwin.png"

// const libraries = ["places"];

// const Field = ({ label, children }) => (
//   <div className="mb-4">
//     <label className="block text-xs font-semibold text-amber-700 uppercase tracking-wider mb-1.5">
//       {label}
//     </label>
//     {children}
//   </div>
// );

// const inputClass =
//   "w-full border border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-100 outline-none rounded-xl px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 transition";

// const QRFormPage = () => {
//   const { qr_id } = useParams();
//   const dispatch = useDispatch();
//   const [showSplash, setShowSplash] = useState(false);
//   const [showText, setShowText] = useState(false);
//   const [otpStep, setOtpStep] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const [otpError, setOtpError] = useState("");
//   const otpRefs = useRef([]);

//   // ✅ Track if fields were auto-filled to show indicator
//   const [autoFilled, setAutoFilled] = useState(false);
//   const mobileDebounceRef = useRef(null);

//   const loading = useSelector((state) => state.qrStatus.loading);
//   const error = useSelector((state) => state.qrStatus.error);
//   const statusInfo = useSelector((state) => state.qrStatus.statusInfo);
//   const redeemSuccess = useSelector((state) => state.consumerReducer?.success);
//   const redeemData = useSelector((state) => state.consumerReducer?.redeemData);

//   const otpLoading = useSelector((state) => state.otp?.loading);
//   const otpApiError = useSelector((state) => state.otp?.otpError);
//   const redeemError = useSelector((state) => state.consumerReducer?.error);
//   const verifyLoading = useSelector((state) => state.consumerReducer?.loading);
//   const [skipOtp, setSkipOtp] = useState(false);
//   const [showPhone, setShowPhone] = useState(false);
//   const [upiError, setUpiError] = useState("");
//   // ✅ Customer details from Redux
//   const { customerData, loading: customerLoading } = useSelector(
//     (state) => state.customerDetails
//   );

//   let redeemNowPayload = null;
// const [mobileError, setMobileError] = useState("");
//   const isRedeemNowOnly =
//     statusInfo?.order_type === "promotional" &&
//     (() => {
//       try {
//         redeemNowPayload = JSON.parse(statusInfo?.fields?.field_1);
//         return !!redeemNowPayload?.is_redeemed;
//       } catch {
//         return false;
//       }
//     })();

//   const isCashbackForm =
//     statusInfo?.order_type === "cashback" &&
//     statusInfo?.fields?.field_1 === "Name" &&
//     statusInfo?.fields?.field_2 === "Mobile" &&
//     statusInfo?.fields?.field_3 === "UPI ID";

//   const [formData, setFormData] = useState({
//     customer_name: "",
//     mobile: "",
//     upi_id: "",
//     address1: "",
//     address: "",
//     city: "",
//     state: "",
//     district:"",
//     pincode: "",
//     lat: "",
//     long: "",
//   });

//   const autocompleteRef = useRef(null);

//   useEffect(() => {
//     if (qr_id) dispatch(checkQRStatus(qr_id));
//   }, [dispatch, qr_id]);

//   useEffect(() => {
//     if (!navigator.geolocation) return;
//     navigator.geolocation.getCurrentPosition(
//       async ({ coords: { latitude, longitude } }) => {
//         const addressData = await fetchAddressFromCoords(latitude, longitude);
//         setFormData((prev) => ({
//           ...prev,
//           lat: latitude,
//           long: longitude,
//           city: addressData.city,
//           state: addressData.state,
//           district:addressData.district,
//           pincode: addressData.pincode,
//           address: addressData.fullAddress,
//         }));
//       },
//       (err) => console.error("Geolocation error:", err)
//     );
//   }, []);

//   const fetchAddressFromCoords = async (lat, long) => {
//     const key = "AIzaSyBjwQjSQoYFe5OzJxbhnodl-usXAt6AH8g";
//     const res = await fetch(
//       `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${key}`
//     );
//     const data = await res.json();
//     if (data.status !== "OK") throw new Error("Geocode failed");
//     const comps = data.results[0].address_components;
//     let city = "", state = "", pincode = "", district = "";
//     comps.forEach(({ types, long_name }) => {
//       if (types.includes("locality")) city = long_name;
//       if (types.includes("administrative_area_level_1")) state = long_name;
//       if (types.includes("postal_code")) pincode = long_name;
//       if (types.includes("administrative_area_level_3")) district = long_name;
//     });
//     return { fullAddress: data.results[0].formatted_address, city, state, district,pincode };
//   };

//   const handlePlaceChanged = () => {
//     const place = autocompleteRef.current?.getPlace();
//     if (!place) return;
//     let city = "", state = "",district ="", pincode = "", lat = "", long = "";
//     place.address_components?.forEach(({ types, long_name }) => {
//       if (types.includes("locality")) city = long_name;
//       if (types.includes("administrative_area_level_1")) state = long_name;
//        if (types.includes("administrative_area_level_3")) district = long_name;
//       if (types.includes("postal_code")) pincode = long_name;
//     });
//     if (place.geometry?.location) {
//       lat = place.geometry.location.lat();
//       long = place.geometry.location.lng();
//     }
//     setFormData((prev) => ({
//       ...prev,
//       address: place.formatted_address,
//       city, state, district, pincode, lat, long,
//     }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "mobile") {
//       let cleaned = value.replace(/\D/g, "");
//       if (cleaned.length === 1 && !/[6-9]/.test(cleaned[0])) return;
//       cleaned = cleaned.slice(0, 10);
//       setFormData((prev) => ({ ...prev, mobile: cleaned }));
//       if (cleaned.length > 0 && cleaned.length < 10) {
//         setMobileError("Mobile number must be exactly 10 digits");
//       } else {
//         setMobileError("");
//       }
//       // ✅ Reset auto-fill indicator when mobile changes
//       if (autoFilled) setAutoFilled(false);
//       if (skipOtp) setSkipOtp(false);
//       setOtpStep(false);
//       // ✅ Debounce: fetch customer details when 10 digits entered
//       clearTimeout(mobileDebounceRef.current);
//       // In handleChange, replace the debounce block:
//       if (cleaned.length === 10) {
//         mobileDebounceRef.current = setTimeout(async () => {
//           const result = await dispatch(getConsumerDetails(cleaned));

//           // ✅ Use result directly — no need to rely on useEffect/Redux state
//           if (result?.success && result?.data?.data) {
//             const details = result.data.data;
//             setFormData((prev) => ({
//               ...prev,
//               customer_name: details.name || prev.customer_name,
//               upi_id: details.upi_id || prev.upi_id,
//             }));
//             setAutoFilled(true);
//             setSkipOtp(true);
//             setOtpStep(false);
//           }
//         }, 400);
//       }
//       return;
//     }
//     if (name === "customer_name") {
//   // Remove numbers, special characters, leading spaces, collapse multiple spaces
//   const cleaned = value
//     .replace(/[^a-zA-Z\s]/g, "")   // allow only letters and spaces
//     .replace(/^\s+/, "")            // no leading space
//     .replace(/\s{2,}/g, " ");       // no double spaces
//   setFormData((prev) => ({ ...prev, [name]: cleaned }));
//   return;
// }
// if (name === "upi_id") {
//   setUpiError(""); // clear error on edit
// }

//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };


//   const handleSendOtp = async (e) => {
//     e.preventDefault();
//      if (formData.mobile.length !== 10) {
//     setMobileError("Mobile number must be exactly 10 digits");
//     return;
//   }
//     if (!formData.lat || !formData.long) {
//       alert("Please select your location from the address field.");
//       return;
//     }
//     if (skipOtp) {
//       dispatch(redeemQr(qr_id, formData));
//       return;
//     }
//     const result = await dispatch(sendOTP(qr_id, formData));
//     if (result?.success) {
//       setOtpStep(true);
//       setOtpError("");

//       // ✅ Auto-fill OTP if returned in response
//       // const otpCode = result?.data?.otp_code?.toString();
//       // if (otpCode) {
//       //   const digits = otpCode.slice(0, 4).split("");
//       //   setOtp(digits);
//       //   otpRefs.current[3]?.focus();
//       // }
//     } else {
//       setOtpError(result?.error || "Failed to send OTP");
//     }
//   };
//   const handleVerifyOtp = async () => {
//     const enteredOtp = otp.join("");
//     if (enteredOtp.length < 4) {
//       setOtpError("Please enter the 4-digit OTP");
//       return;
//     }
//     const redeemPayload = { ...formData, otp_code: enteredOtp };
//     dispatch(redeemQr(qr_id, redeemPayload));
//   };

//   // const handleOtpChange = (index, value) => {

//   //   if (!/^\d?$/.test(value)) return;
//   //   const updated = [...otp];
//   //   updated[index] = value;
//   //   setOtp(updated);
//   //   if (value && index < 3) otpRefs.current[index + 1]?.focus();
//   // };
// // In handleOtpChange
// const handleOtpChange = (index, value) => {
//   if (!/^\d?$/.test(value)) return;
//   const updated = [...otp];
//   updated[index] = value;
//   setOtp(updated);
//   if (otpError) setOtpError(""); // ← add this line
//   if (value && index < 3) otpRefs.current[index + 1]?.focus();
// };
//   const handleOtpKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       otpRefs.current[index - 1]?.focus();
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!formData.lat || !formData.long) {
//       alert("Please select your location from the address field.");
//       return;
//     }
//     dispatch(redeemQr(qr_id, formData));
//   };


//   // useEffect(() => {
//   //   if (redeemSuccess) {
//   //     setShowSplash(true);
//   //     setTimeout(() => setShowText(true), 1000);
//   //   } else if (redeemError) {
//   //     const isOtpError = /otp|invalid/i.test(redeemError);

//   //     if (isOtpError && otpStep) {
//   //       setOtpError(redeemError);        // show inline on OTP screen
//   //       setOtp(["", "", "", ""]);        // clear boxes for re-entry
//   //       otpRefs.current[0]?.focus();     // focus first box
//   //     } else {
//   //       setShowSplash(true);
//   //       setTimeout(() => setShowText(true), 1000);
//   //     }
//   //   }
//   // }, [redeemSuccess, redeemError]);


//   useEffect(() => {
//   if (redeemSuccess) {
//     setShowSplash(true);
//     setTimeout(() => setShowText(true), 1000);
//   } else if (redeemError) {
//     const isOtpError = /otp|invalid otp/i.test(redeemError);
//     // const isUpiError = /upi|vpa|account|beneficiary|invalid/i.test(redeemError);
//     //  const isUpiError =
//     //   !!redeemError &&                                          // ← guard against ""
//     //   /upi|vpa|account|beneficiary|invalid/i.test(redeemError);

//     const isUpiError =
//   !!redeemError &&
//   /upi|vpa|account|beneficiary|invalid|transfer failed|valid virtual|payee address/i.test(redeemError);
//     if (isOtpError && otpStep) {
//       setOtpError(redeemError);
//       setOtp(["", "", "", ""]);
//       otpRefs.current[0]?.focus();
//     } else if (isUpiError) {
//       setUpiError(redeemError);        // show inline under UPI field
//       setOtpStep(false);               // go back to form screen
//     } else {
//       setShowSplash(true);
//       setTimeout(() => setShowText(true), 1000);
//     }
//   }
// }, [redeemSuccess, redeemError]);
//   const handleRedeemNow = () => {
//     if (!navigator.geolocation) { alert("Geolocation not supported"); return; }
//     navigator.geolocation.getCurrentPosition(
//       async ({ coords: { latitude, longitude } }) => {
//         const addressData = await fetchAddressFromCoords(latitude, longitude);
//         const payload = {
//           ...redeemNowPayload,
//           lat: latitude, long: longitude,
//           address: addressData.fullAddress,
//           city: addressData.city,
//           state: addressData.state,
//           pincode: addressData.pincode,
//         };
//         dispatch(redeemQr(qr_id, payload));
//         setShowSplash(true);
//         setTimeout(() => setShowText(true), 1000);
//       },
//       (err) => { console.error(err); alert("Please allow location access."); }
//     );
//   };


//   /* ── Loading ── */
//   if (loading) {
//     return (
//       <div className="min-h-screen bg-amber-50 flex flex-col items-center justify-center gap-3">
//         <div className="w-10 h-10 border-4 border-amber-200 border-t-amber-600 rounded-full animate-spin" />
//         <p className="text-amber-700 text-sm font-medium">Checking QR status…</p>
//       </div>
//     );
//   }

//   /* ── Error ── */
//   if (error || statusInfo?.status !== 200) {
//     return (
//       <div className="min-h-screen bg-amber-400 flex items-center justify-center px-4">
//         <div className="bg-white rounded-2xl border border-black shadow p-8 max-w-sm w-full text-center">
//           <div className="w-32 h-32 rounded-full  flex items-center justify-center mx-auto mb-4">
//             <img src={logo} alt="Logo" className="w-32 h-32 object-contain" />
//           </div>
//           <p className="text-red-600 font-medium text-md">
//             {error?.message || statusInfo?.message || "QR code invalid or expired."}
//           </p>
//         </div>
//       </div>
//     );
//   }

//   /* ── Splash ── */
//   // if (showSplash) {
//   //   return (
//   //     <div className="min-h-screen bg-amber-50 flex flex-col items-center justify-center text-center px-4 py-8">
//   //       <DotLottieReact
//   //         // src="https://lottie.host/a234dcc4-75a9-44d4-950d-694e67679d93/KaZ3dZuMvu.lottie"
//   //         src="https://lottie.host/328462f3-8aef-4168-96f4-f12c23a15c85/OhTqExamQl.lottie"

//   //         loop autoplay
//   //         style={{ width: 200, height: 200 }}
//   //       />
//   //       <h1 className="text-3xl font-bold text-amber-800">{redeemData?.header}</h1>
//   //       <p className="text-black font-medium text-md mt-1">
//   //         {redeemData?.slogan_message}
//   //       </p>
//   //       <div className="bg-white rounded-2xl border border-amber-800 shadow-md w-full max-w-sm mt-6 overflow-hidden">
//   //         <div className=" border-b border-amber-800 px-6 py-5">
//   //           <p className="text-xs font-bold text-black-400 uppercase tracking-widest mb-1">Cashback Amount</p>
//   //           <p className="text-5xl font-bold text-amber-600 leading-none">
//   //             ₹{redeemData?.amount}
//   //           </p>
//   //         </div>
//   //         <div className="px-6 py-5 flex flex-col gap-4">
//   //           <div className="bg-amber-50 border border-amber-800 rounded-xl px-4 py-3 text-left">
//   //             {redeemData?.cashfree_status?.transfer_payment && (
//   //               <p className={`text-sm font-medium mt-2  mb-2 ${redeemData.cashfree_status.transfer_payment.status === "SUCCESS" ? "text-green-600" : "text-red-500"}`}>
//   //                 Transfer Status: {redeemData.cashfree_status.transfer_payment.status} —{" "}
//   //                 {redeemData.cashfree_status.transfer_payment.message}
//   //               </p>
//   //             )}
//   //             <p className="text-sm text-black font-medium leading-relaxed">
//   //               <span className="font-bold">Note:</span> The amount will be credited to your account within{" "}
//   //               <span className="font-bold">24 hours</span>.
//   //             </p>
//   //           </div>

//   //           <div className="bg-gray-50 border border-amber-800 rounded-xl px-4 py-3 text-center">
//   //             <p className="text-xs text-gray-500 mb-1">Need help?</p>
//   //             {!showPhone && (
//   //               <button
//   //                 type="button"
//   //                 onClick={() => setShowPhone(true)}
//   //                 className="text-xs text-gray-500 underline"
//   //               >
//   //                 Contact Support
//   //               </button>
//   //             )}
//   //             {showPhone && (
//   //               <a
//   //                 href="tel:+919999999999"
//   //                 className="block text-xs text-gray-500 tracking-wide mt-2"
//   //               >
//   //                 📞 +91 99 999 999 99
//   //               </a>
//   //             )}
//   //           </div>
//   //         </div>
//   //       </div>
//   //     </div>
//   //   );
//   // }

//   if (showSplash) {
//   const isSuccess = redeemSuccess;

//   return (
//     <div className="min-h-screen bg-amber-50 flex flex-col items-center justify-center text-center px-4 py-8">
//       <DotLottieReact
//         src={
//           isSuccess
//             ? "https://lottie.host/328462f3-8aef-4168-96f4-f12c23a15c85/OhTqExamQl.lottie"
//             : "https://lottie.host/010f1c59-6bee-491a-a350-83ac90c25f05/CJEvrX5r3M.lottie" // replace with a failure lottie
//         }
//         loop
//         autoplay
//         style={{ width: 200, height: 200 }}
//       />
//       <h1 className={`text-3xl font-bold ${isSuccess ? "text-amber-800" : "text-red-600"}`}>
//         {redeemData?.header}
//       </h1>
//       <p className={`font-medium text-md mt-1 ${isSuccess ? "text-black" : "text-green-600"}`}>
//         {redeemData?.slogan_message}
//       </p>

//       <div className="bg-white rounded-2xl border border-amber-800 shadow-md w-full max-w-sm mt-6 overflow-hidden">
//         {isSuccess && (
//           <div className="border-b border-amber-800 px-6 py-5">

//             <p className="text-xs font-bold text-black uppercase tracking-widest mb-1">
//               Cashback Amount
//             </p>


//             <p className="text-5xl font-bold leading-none text-amber-600">
//               ₹{redeemData?.amount}
//             </p>

//           </div>
//         )}
//         <div className="px-6 py-5 flex flex-col gap-4">
//           {/* <div className={`border rounded-xl px-4 py-3 text-left ${isSuccess ? "bg-amber-50 border-amber-800" : "bg-red-50 border-red-300"}`}>

//             {redeemData?.cashfree_status?.transfer_payment && isSuccess &&  (
//               <p className={`text-sm font-medium mb-2 ${redeemData.cashfree_status.transfer_payment.status === "SUCCESS" ? "text-green-600" : "text-red-500"}`}>
//                 Transfer Status: {redeemData.cashfree_status.transfer_payment.status} —{" "}
//                 {redeemData.cashfree_status.transfer_payment.message}
//               </p>
//             )}
//             <p className="text-sm text-black font-medium leading-relaxed">
//               <span className="font-bold">Note:</span>{" "}
//               {isSuccess
//                 ? "The amount will be credited to your account within 24 hours."
//                 : redeemData?.message || "Redemption failed. Please try again later."}
//             </p>
//           </div> */}
//           <div className={`border rounded-xl px-4 py-3 text-left ${isSuccess ? "bg-amber-50 border-amber-800" : "bg-red-50 border-red-300"}`}>
//   {isSuccess && redeemData?.cashfree_status?.transfer_payment && (
//     <p className={`text-sm font-medium mb-2 ${redeemData.cashfree_status.transfer_payment.status === "SUCCESS" ? "text-green-600" : "text-red-500"}`}>
//       Transfer Status: {redeemData.cashfree_status.transfer_payment.status} —{" "}
//       {redeemData.cashfree_status.transfer_payment.message}
//     </p>
//   )}

//   {!isSuccess && redeemData?.cashfree_status?.transfer_payment && (() => {
//     // Extract statusDescription from the message string
//     const raw = redeemData.cashfree_status.transfer_payment.message || "";
//     const match = raw.match(/'statusDescription':\s*'([^']+)'/);
//     const statusDescription = match ? match[1] : null;

//     return (
//       <p className="text-xs text-red-600  mb-2">
//         {statusDescription || raw}
//       </p>
//     );
//   })()}

//   <p className="text-sm text-black font-medium leading-relaxed">
//     <span className="font-bold">Note:</span>{" "}
//     {isSuccess
//       ? "The amount will be credited to your account within 24 hours."
//       : redeemData?.message || "Redemption failed. Please try again later."}
//   </p>
// </div>
//           <div className="bg-gray-50 border border-amber-800 rounded-xl px-4 py-3 text-center">
//             <p className="text-xs text-gray-500 mb-1">Need help?</p>
//             {!showPhone && (
//               <button type="button" onClick={() => setShowPhone(true)} className="text-xs text-gray-500 underline">
//                 Contact Support
//               </button>
//             )}
//             {showPhone && (
//               <a href="tel:+919999999999" className="block text-xs text-gray-500 tracking-wide mt-2">
//                 📞 +91 99 999 999 99
//               </a>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
//   /* ── Main Card ── */
//   return (
//     <div className="min-h-screen bg-amber-400 flex items-center justify-center px-4 py-2">
//       <div className="bg-white rounded-2xl border border-amber-800 shadow-md w-full max-w-md p-8">

//         {/* Logo + Header */}
//         <div className="flex flex-col items-center mb-6">
//           {/* <img src={logo} alt="Logo" className="w-28 h-28 object-contain mb-3 " />
//            */}
//           <div className="flex items-center gap-3 mb-3">
//             <img src={scannwin} alt="ScannWin" className="w-28 h-28 object-contain" />
//             <img src={logo} alt="Logo" className="w-28 h-28 object-contain" />

//           </div>
//           <h2 className="text-xl font-bold text-amber-800 text-center">
//             {isCashbackForm ? "Easy Rewardz" : isRedeemNowOnly ? "Redeem Now" : "QR Redemption"}
//           </h2>

//           <span className="mt-3 inline-flex items-center gap-1.5 bg-amber-50 border border-amber-400 rounded-full px-3 py-1 text-sm font-medium text-amber-800">

//             QR is Active & Valid
//           </span>
//         </div>

//         {statusInfo?.message && (
//           <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-red-600 text-sm text-center font-medium mb-5">
//             {statusInfo.message}
//           </div>
//         )}

//         {/* ── Redeem Now ── */}
//         {isRedeemNowOnly && (
//           <div className="text-center py-2">
//             <p className="text-sm text-gray-500 mb-6 leading-relaxed">
//               This is a promotional QR. Tap the button below to redeem your reward instantly.
//             </p>
//             <button
//               onClick={handleRedeemNow}
//               className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 rounded-xl transition shadow-sm hover:shadow-md text-sm"
//             >
//               Redeem Now
//             </button>
//           </div>
//         )}

//         {/* ── Cashback Form ── */}
//         {isCashbackForm && (
//           <form onSubmit={otpStep ? (e) => { e.preventDefault(); handleVerifyOtp(); } : handleSendOtp}>

//             {/* Mobile — always first so fetch can happen before other fields */}
//             <Field label="Mobile Number *">
//               <div className="relative">
//                 <input
//                   type="text"
//                   name="mobile"
//                   placeholder="10-digit mobile number"
//                   value={formData.mobile}
//                   onChange={handleChange}
//                   required
//                   className={inputClass}
//                 />
//                 {/* ✅ Spinner while fetching */}
//                 {customerLoading && (
//                   <span className="absolute right-3 top-1/2 -translate-y-1/2">
//                     <svg className="w-4 h-4 animate-spin text-amber-500" viewBox="0 0 24 24" fill="none">
//                       <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                       <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
//                     </svg>
//                   </span>
//                 )}
//                 {formData.mobile.length === 10 && !mobileError && (
//                   <span className="absolute right-3 top-1/2 -translate-y-1/2 text-green-500 text-base">✓</span>
//                 )}
//               </div>
//               {mobileError && (
//                 <p className="text-red-500 text-xs mt-1 ml-1">{mobileError}</p>
//               )}
//             </Field>

//             {/* ✅ Auto-fill banner */}
//             {autoFilled && (
//               <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-xl px-3 py-2 mb-4 text-xs text-green-700 font-medium">
//                 <span className="text-green-500 text-base">✓</span>
//                 Details found & auto-filled from your previous redemption.
//               </div>
//             )}

//             <Field label="Name *">
//               <input
//                 type="text"
//                 name="customer_name"
//                 placeholder="Your full name"
//                 value={formData.customer_name}
//                 onChange={handleChange}
//                 required
//                 className={inputClass}
//               />
//             </Field>

//             <Field label="UPI ID *">
//               <input
//                 type="text"
//                 name="upi_id"
//                 placeholder="name@bank"
//                 value={formData.upi_id}
//                 onChange={handleChange}
//                 pattern="^[a-zA-Z0-9._-]{2,}@[a-zA-Z]{2,}$"
//                 title="Enter a valid UPI ID (e.g., name@bank)"
//                 required
//                 className={`${inputClass} ${upiError ? "border-red-400 focus:border-red-400 focus:ring-red-100" : ""}`}
//               />
//               {upiError && (
//                 <p className="text-red-500 text-xs mt-1 ml-1">{upiError}</p>
//               )}
//             </Field>
//             <Field label="Place">
//               <input
//                 type="text"
//                 name="address1"
//                 placeholder="Enter place name (e.g. shop, landmark)"
//                 value={formData.address1}
//                 onChange={handleChange}
//                 className={inputClass}
//               />
//             </Field>

//             <div className="border-t border-amber-100 my-4" />

//             <Field label="Address">
//               <LoadScriptNext
//                 googleMapsApiKey="AIzaSyBjwQjSQoYFe5OzJxbhnodl-usXAt6AH8g"
//                 libraries={libraries}
//               >
//                 <Autocomplete
//                   onLoad={(ref) => (autocompleteRef.current = ref)}
//                   onPlaceChanged={handlePlaceChanged}
//                 >
//                   <input
//                     type="text"
//                     name="address"
//                     value={formData.address}
//                     onChange={handleChange}
//                     placeholder="Start typing your address…"
//                     required
//                     className={inputClass}
//                   />
//                 </Autocomplete>
//               </LoadScriptNext>
//             </Field>

//             {/* {!otpStep ? (
//               <button
//                 type="submit"
//                 disabled={otpLoading}
//                 className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 rounded-xl transition shadow-sm hover:shadow-md text-sm mt-2 disabled:opacity-60"
//               >
//                 {otpLoading ? "Sending OTP…" : "Send OTP →"}
//               </button>
//             ) : ( */}
//             {!otpStep ? (
//               <button
//                 type="submit"
//                 disabled={otpLoading}
//                 className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 rounded-xl transition shadow-sm hover:shadow-md text-sm mt-2 disabled:opacity-60"
//               >
//                 {otpLoading
//                   ? "Submitting…"
//                   : skipOtp
//                     ? "Submit →"          // ← different label when skipping OTP
//                     : "Send OTP →"}
//               </button>
//             ) : (
//               // ✅ Only render OTP block if NOT skipping
//               !skipOtp && (

//                 <div className="mt-2">
//                   {/* <p className="text-xs text-gray-500 text-center mb-3">
//                     OTP sent to <span className="font-semibold text-amber-600">{formData.mobile}</span>
//                     <button
//                       type="button"
//                       onClick={() => { setOtpStep(false); setOtp(["", "", "", ""]); setOtpError(""); }}
//                       className="ml-2 text-amber-500 underline text-xs"
//                     >
//                       Change
//                     </button>
//                   </p> */}
//                   <div className="flex justify-center gap-2 mb-3">
//                     {otp.map((digit, i) => (
//                       <input
//                         key={i}
//                         ref={(el) => (otpRefs.current[i] = el)}
//                         type="text"
//                         inputMode="numeric"
//                         maxLength={1}
//                         value={digit}
//                         onChange={(e) => handleOtpChange(i, e.target.value)}
//                         onKeyDown={(e) => handleOtpKeyDown(i, e)}
//                         className="w-11 h-12 text-center text-lg font-bold border-2 border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-100 rounded-xl outline-none transition"
//                       />
//                     ))}
//                   </div>
//                   {(otpError || otpApiError) && (
//                     <p className="text-red-500 text-xs text-center mb-2">{otpError || otpApiError}</p>
//                   )}
//                   <button
//                     type="button"
//                     onClick={handleVerifyOtp}
//                     disabled={verifyLoading}
//                     className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 rounded-xl transition shadow-sm hover:shadow-md text-sm disabled:opacity-60"
//                   >
//                     {verifyLoading ? "Verifying…" : "Verify & Submit →"}
//                   </button>
//                   {/* <p className="text-center text-xs text-gray-400 mt-3">
//                     Didn't receive?{" "}
//                     <button
//                       type="button"
//                       onClick={() => { setOtp(["", "", "", ""]); setOtpError(""); }}
//                       className="text-amber-600 underline"
//                     >
//                       Resend OTP
//                     </button>
//                   </p> */}
//                 </div>
//               )
//             )}
//           </form>
//         )}

//         {/* ── Fallback ── */}
//         {!isRedeemNowOnly && !isCashbackForm && (
//           <p className="text-center text-gray-500 text-sm py-4">
//             This QR is not valid for redemption.
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default QRFormPage;

import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkQRStatus, redeemQr, sendOTP, getConsumerDetails } from "../../redux/actions/consumerActions";
import { LoadScriptNext, Autocomplete } from "@react-google-maps/api";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import logo from "../../assets/logo/shubam.png";
import scannwin from "../../assets/logo/scannwin.png";

const libraries = ["places"];

const Field = ({ label, children }) => (
  <div className="mb-4">
    <label className="block text-xs font-semibold text-amber-700 uppercase tracking-wider mb-1.5">
      {label}
    </label>
    {children}
  </div>
);

const inputClass =
  "w-full border border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-100 outline-none rounded-xl px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 transition";

const QRFormPage = () => {
  const { qr_id } = useParams();
  const dispatch = useDispatch();
  const [showSplash, setShowSplash] = useState(false);
  const [showText, setShowText] = useState(false);
  const [otpStep, setOtpStep] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const otpRefs = useRef([]);

  const [autoFilled, setAutoFilled] = useState(false);
  const mobileDebounceRef = useRef(null);

  const loading = useSelector((state) => state.qrStatus.loading);
  const error = useSelector((state) => state.qrStatus.error);
  const statusInfo = useSelector((state) => state.qrStatus.statusInfo);
  const redeemSuccess = useSelector((state) => state.consumerReducer?.success);
  const redeemData = useSelector((state) => state.consumerReducer?.redeemData);

  const otpLoading = useSelector((state) => state.otp?.loading);
  const otpApiError = useSelector((state) => state.otp?.otpError);
  const redeemError = useSelector((state) => state.consumerReducer?.error);
  const verifyLoading = useSelector((state) => state.consumerReducer?.loading);
  const [skipOtp, setSkipOtp] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const [upiError, setUpiError] = useState("");

  const { customerData, loading: customerLoading } = useSelector(
    (state) => state.customerDetails
  );

  let redeemNowPayload = null;
  const [mobileError, setMobileError] = useState("");

  const isRedeemNowOnly =
    statusInfo?.order_type === "promotional" &&
    (() => {
      try {
        redeemNowPayload = JSON.parse(statusInfo?.fields?.field_1);
        return !!redeemNowPayload?.is_redeemed;
      } catch {
        return false;
      }
    })();

  const isCashbackForm =
    statusInfo?.order_type === "cashback" &&
    statusInfo?.fields?.field_1 === "Name" &&
    statusInfo?.fields?.field_2 === "Mobile" &&
    statusInfo?.fields?.field_3 === "UPI ID";

  const [formData, setFormData] = useState({
    customer_name: "",
    mobile: "",
    upi_id: "",
    address1: "",
    address: "",
    city: "",
    state: "",
    district: "",
    pincode: "",
    lat: "",
    long: "",
  });

  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (qr_id) dispatch(checkQRStatus(qr_id));
  }, [dispatch, qr_id]);

  // Silently capture geolocation in background
  useEffect(() => {
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        const addressData = await fetchAddressFromCoords(latitude, longitude);
        setFormData((prev) => ({
          ...prev,
          lat: latitude,
          long: longitude,
          city: addressData.city,
          state: addressData.state,
          district: addressData.district,
          pincode: addressData.pincode,
          address: addressData.fullAddress,
        }));
      },
      (err) => console.error("Geolocation error:", err)
    );
  }, []);

  const fetchAddressFromCoords = async (lat, long) => {
    const key = "AIzaSyBjwQjSQoYFe5OzJxbhnodl-usXAt6AH8g";
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${key}`
    );
    const data = await res.json();
    if (data.status !== "OK") throw new Error("Geocode failed");
    const comps = data.results[0].address_components;
    let city = "", state = "", pincode = "", district = "";
    comps.forEach(({ types, long_name }) => {
      if (types.includes("locality")) city = long_name;
      if (types.includes("administrative_area_level_1")) state = long_name;
      if (types.includes("postal_code")) pincode = long_name;
      if (types.includes("administrative_area_level_3")) district = long_name;
    });
    return { fullAddress: data.results[0].formatted_address, city, state, district, pincode };
  };

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current?.getPlace();
    if (!place) return;
    let city = "", state = "", district = "", pincode = "", lat = "", long = "";
    place.address_components?.forEach(({ types, long_name }) => {
      if (types.includes("locality")) city = long_name;
      if (types.includes("administrative_area_level_1")) state = long_name;
      if (types.includes("administrative_area_level_3")) district = long_name;
      if (types.includes("postal_code")) pincode = long_name;
    });
    if (place.geometry?.location) {
      lat = place.geometry.location.lat();
      long = place.geometry.location.lng();
    }
    setFormData((prev) => ({
      ...prev,
      address: place.formatted_address,
      city, state, district, pincode, lat, long,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      let cleaned = value.replace(/\D/g, "");
      if (cleaned.length === 1 && !/[6-9]/.test(cleaned[0])) return;
      cleaned = cleaned.slice(0, 10);
      setFormData((prev) => ({ ...prev, mobile: cleaned }));
      if (cleaned.length > 0 && cleaned.length < 10) {
        setMobileError("Mobile number must be exactly 10 digits");
      } else {
        setMobileError("");
      }
      if (autoFilled) setAutoFilled(false);
      if (skipOtp) setSkipOtp(false);
      setOtpStep(false);

      clearTimeout(mobileDebounceRef.current);
      if (cleaned.length === 10) {
        mobileDebounceRef.current = setTimeout(async () => {
          const result = await dispatch(getConsumerDetails(cleaned));
          if (result?.success && result?.data?.data) {
            const details = result.data.data;
            setFormData((prev) => ({
              ...prev,
              customer_name: details.name || prev.customer_name,
              upi_id: details.upi_id || prev.upi_id,
            }));
            setAutoFilled(true);
            setSkipOtp(true);
            setOtpStep(false);
          }
        }, 400);
      }
      return;
    }

    if (name === "customer_name") {
      const cleaned = value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/^\s+/, "")
        .replace(/\s{2,}/g, " ");
      setFormData((prev) => ({ ...prev, [name]: cleaned }));
      return;
    }

    if (name === "upi_id") {
      setUpiError("");
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (formData.mobile.length !== 10) {
      setMobileError("Mobile number must be exactly 10 digits");
      return;
    }
    // Location is captured silently in background — no alert needed
    if (skipOtp) {
      dispatch(redeemQr(qr_id, formData));
      return;
    }
    const result = await dispatch(sendOTP(qr_id, formData));
    if (result?.success) {
      setOtpStep(true);
      setOtpError("");
    } else {
      setOtpError(result?.error || "Failed to send OTP");
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length < 4) {
      setOtpError("Please enter the 4-digit OTP");
      return;
    }
    const redeemPayload = { ...formData, otp_code: enteredOtp };
    dispatch(redeemQr(qr_id, redeemPayload));
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);
    if (otpError) setOtpError("");
    if (value && index < 3) otpRefs.current[index + 1]?.focus();
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpRefs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Location is captured silently in background — no alert needed
    dispatch(redeemQr(qr_id, formData));
  };

  useEffect(() => {
    if (redeemSuccess) {
      setShowSplash(true);
      setTimeout(() => setShowText(true), 1000);
    } else if (redeemError) {
      const isOtpError = /otp|invalid otp/i.test(redeemError);
      const isUpiError =
        !!redeemError &&
        /upi|vpa|account|beneficiary|invalid|transfer failed|valid virtual|payee address/i.test(redeemError);

      if (isOtpError && otpStep) {
        setOtpError(redeemError);
        setOtp(["", "", "", ""]);
        otpRefs.current[0]?.focus();
      } else if (isUpiError) {
        setUpiError(redeemError);
        setOtpStep(false);
      } else {
        setShowSplash(true);
        setTimeout(() => setShowText(true), 1000);
      }
    }
  }, [redeemSuccess, redeemError]);

  const handleRedeemNow = () => {
    if (!navigator.geolocation) { alert("Geolocation not supported"); return; }
    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        const addressData = await fetchAddressFromCoords(latitude, longitude);
        const payload = {
          ...redeemNowPayload,
          lat: latitude, long: longitude,
          address: addressData.fullAddress,
          city: addressData.city,
          state: addressData.state,
          pincode: addressData.pincode,
        };
        dispatch(redeemQr(qr_id, payload));
        setShowSplash(true);
        setTimeout(() => setShowText(true), 1000);
      },
      (err) => { console.error(err); alert("Please allow location access."); }
    );
  };

  /* ── Loading ── */
  if (loading) {
    return (
      <div className="min-h-screen bg-amber-50 flex flex-col items-center justify-center gap-3">
        <div className="w-10 h-10 border-4 border-amber-200 border-t-amber-600 rounded-full animate-spin" />
        <p className="text-amber-700 text-sm font-medium">Checking QR status…</p>
      </div>
    );
  }

  /* ── Error ── */
  if (error || statusInfo?.status !== 200) {
    return (
      <div className="min-h-screen bg-amber-400 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl border border-black shadow p-8 max-w-sm w-full text-center">
          <div className="w-32 h-32 rounded-full flex items-center justify-center mx-auto mb-4">
            <img src={logo} alt="Logo" className="w-32 h-32 object-contain" />
          </div>
          <p className="text-red-600 font-medium text-md">
            {error?.message || statusInfo?.message || "QR code invalid or expired."}
          </p>
        </div>
      </div>
    );
  }

  /* ── Splash ── */
  if (showSplash) {
    const isSuccess = redeemSuccess;

    return (
      <div className="min-h-screen bg-amber-50 flex flex-col items-center justify-center text-center px-4 py-8">
        <DotLottieReact
          src={
            isSuccess
              ? "https://lottie.host/328462f3-8aef-4168-96f4-f12c23a15c85/OhTqExamQl.lottie"
              : "https://lottie.host/010f1c59-6bee-491a-a350-83ac90c25f05/CJEvrX5r3M.lottie"
          }
          loop
          autoplay
          style={{ width: 200, height: 200 }}
        />
        <h1 className={`text-3xl font-bold ${isSuccess ? "text-amber-800" : "text-red-600"}`}>
          {redeemData?.header}
        </h1>
        <p className={`font-medium text-md mt-1 ${isSuccess ? "text-black" : "text-green-600"}`}>
          {redeemData?.slogan_message}
        </p>

        <div className="bg-white rounded-2xl border border-amber-800 shadow-md w-full max-w-sm mt-6 overflow-hidden">
          {isSuccess && (
            <div className="border-b border-amber-800 px-6 py-5">
              <p className="text-xs font-bold text-black uppercase tracking-widest mb-1">
                Cashback Amount
              </p>
              <p className="text-5xl font-bold leading-none text-amber-600">
                ₹{redeemData?.amount}
              </p>
            </div>
          )}
          <div className="px-6 py-5 flex flex-col gap-4">
            <div className={`border rounded-xl px-4 py-3 text-left ${isSuccess ? "bg-amber-50 border-amber-800" : "bg-red-50 border-red-300"}`}>
              {isSuccess && redeemData?.cashfree_status?.transfer_payment && (
                <p className={`text-sm font-medium mb-2 ${redeemData.cashfree_status.transfer_payment.status === "SUCCESS" ? "text-green-600" : "text-red-500"}`}>
                  Transfer Status: {redeemData.cashfree_status.transfer_payment.status} —{" "}
                  {redeemData.cashfree_status.transfer_payment.message}
                </p>
              )}

              {!isSuccess && redeemData?.cashfree_status?.transfer_payment && (() => {
                const raw = redeemData.cashfree_status.transfer_payment.message || "";
                const match = raw.match(/'statusDescription':\s*'([^']+)'/);
                const statusDescription = match ? match[1] : null;
                return (
                  <p className="text-xs text-red-600 mb-2">
                    {statusDescription || raw}
                  </p>
                );
              })()}

              <p className="text-sm text-black font-medium leading-relaxed">
                <span className="font-bold">Note:</span>{" "}
                {isSuccess
                  ? "The amount will be credited to your account within 24 hours."
                  : redeemData?.message || "Redemption failed. Please try again later."}
              </p>
            </div>

            <div className="bg-gray-50 border border-amber-800 rounded-xl px-4 py-3 text-center">
              <p className="text-xs text-gray-500 mb-1">Need help?</p>
              {!showPhone && (
                <button type="button" onClick={() => setShowPhone(true)} className="text-xs text-gray-500 underline">
                  Contact Support
                </button>
              )}
              {showPhone && (
                <a href="tel:+919999999999" className="block text-xs text-gray-500 tracking-wide mt-2">
                  📞 +91 99 999 999 99
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ── Main Card ── */
  return (
    <div className="min-h-screen bg-amber-400 flex items-center justify-center px-4 py-2">
      <div className="bg-white rounded-2xl border border-amber-800 shadow-md w-full max-w-md p-8">

        {/* Logo + Header */}
        <div className="flex flex-col items-center mb-6">
          <div className="flex items-center gap-3 mb-3">
            <img src={scannwin} alt="ScannWin" className="w-28 h-28 object-contain" />
            <img src={logo} alt="Logo" className="w-28 h-28 object-contain" />
          </div>
          <h2 className="text-xl font-bold text-amber-800 text-center">
            {isCashbackForm ? "Easy Rewardz" : isRedeemNowOnly ? "Redeem Now" : "QR Redemption"}
          </h2>
          <span className="mt-3 inline-flex items-center gap-1.5 bg-amber-50 border border-amber-400 rounded-full px-3 py-1 text-sm font-medium text-amber-800">
            QR is Active & Valid
          </span>
        </div>

        {statusInfo?.message && (
          <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-red-600 text-sm text-center font-medium mb-5">
            {statusInfo.message}
          </div>
        )}

        {/* ── Redeem Now ── */}
        {isRedeemNowOnly && (
          <div className="text-center py-2">
            <p className="text-sm text-gray-500 mb-6 leading-relaxed">
              This is a promotional QR. Tap the button below to redeem your reward instantly.
            </p>
            <button
              onClick={handleRedeemNow}
              className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 rounded-xl transition shadow-sm hover:shadow-md text-sm"
            >
              Redeem Now
            </button>
          </div>
        )}

        {/* ── Cashback Form ── */}
        {isCashbackForm && (
          <form onSubmit={otpStep ? (e) => { e.preventDefault(); handleVerifyOtp(); } : handleSendOtp}>

            {/* Mobile */}
            <Field label="Mobile Number *">
              <div className="relative">
                <input
                  type="text"
                  name="mobile"
                  placeholder="10-digit mobile number"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
                {customerLoading && (
                  <span className="absolute right-3 top-1/2 -translate-y-1/2">
                    <svg className="w-4 h-4 animate-spin text-amber-500" viewBox="0 0 24 24" fill="none">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                    </svg>
                  </span>
                )}
                {formData.mobile.length === 10 && !mobileError && (
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-green-500 text-base">✓</span>
                )}
              </div>
              {mobileError && (
                <p className="text-red-500 text-xs mt-1 ml-1">{mobileError}</p>
              )}
            </Field>

            {/* Auto-fill banner */}
            {autoFilled && (
              <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-xl px-3 py-2 mb-4 text-xs text-green-700 font-medium">
                <span className="text-green-500 text-base">✓</span>
                Details found & auto-filled from your previous redemption.
              </div>
            )}

            <Field label="Name *">
              <input
                type="text"
                name="customer_name"
                placeholder="Your full name"
                value={formData.customer_name}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </Field>

            <Field label="UPI ID *">
              <input
                type="text"
                name="upi_id"
                placeholder="name@bank"
                value={formData.upi_id}
                onChange={handleChange}
                pattern="^[a-zA-Z0-9._-]{2,}@[a-zA-Z]{2,}$"
                title="Enter a valid UPI ID (e.g., name@bank)"
                required
                className={`${inputClass} ${upiError ? "border-red-400 focus:border-red-400 focus:ring-red-100" : ""}`}
              />
              {upiError && (
                <p className="text-red-500 text-xs mt-1 ml-1">{upiError}</p>
              )}
            </Field>
            <Field label="Place">
              <input
                type="text"
                name="address1"
                placeholder="Enter place name (e.g. shop, landmark)"
                value={formData.address1}
                onChange={handleChange}
                className={inputClass}
              />
            </Field>
            {/* ── Hidden fields — tracked silently, sent in payload ── */}
            <div className="hidden">
              <Field label="Place">
                <input
                  type="text"
                  name="address1"
                  placeholder="Enter place name (e.g. shop, landmark)"
                  value={formData.address1}
                  onChange={handleChange}
                  className={inputClass}
                />
              </Field>

              <Field label="Address">
                <LoadScriptNext
                  googleMapsApiKey="AIzaSyBjwQjSQoYFe5OzJxbhnodl-usXAt6AH8g"
                  libraries={libraries}
                >
                  <Autocomplete
                    onLoad={(ref) => (autocompleteRef.current = ref)}
                    onPlaceChanged={handlePlaceChanged}
                  >
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Start typing your address…"
                      className={inputClass}
                    />
                  </Autocomplete>
                </LoadScriptNext>
              </Field>
            </div>

            {/* Submit / OTP */}
            {!otpStep ? (
              <button
                type="submit"
                disabled={otpLoading}
                className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 rounded-xl transition shadow-sm hover:shadow-md text-sm mt-2 disabled:opacity-60"
              >
                {otpLoading
                  ? "Submitting…"
                  : skipOtp
                    ? "Submit →"
                    : "Send OTP →"}
              </button>
            ) : (
              !skipOtp && (
                <div className="mt-2">
                  <div className="flex justify-center gap-2 mb-3">
                    {otp.map((digit, i) => (
                      <input
                        key={i}
                        ref={(el) => (otpRefs.current[i] = el)}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleOtpChange(i, e.target.value)}
                        onKeyDown={(e) => handleOtpKeyDown(i, e)}
                        className="w-11 h-12 text-center text-lg font-bold border-2 border-gray-300 focus:border-amber-500 focus:ring-2 focus:ring-amber-100 rounded-xl outline-none transition"
                      />
                    ))}
                  </div>
                  {(otpError || otpApiError) && (
                    <p className="text-red-500 text-xs text-center mb-2">{otpError || otpApiError}</p>
                  )}
                  <button
                    type="button"
                    onClick={handleVerifyOtp}
                    disabled={verifyLoading}
                    className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-3 rounded-xl transition shadow-sm hover:shadow-md text-sm disabled:opacity-60"
                  >
                    {verifyLoading ? "Verifying…" : "Verify & Submit →"}
                  </button>
                </div>
              )
            )}
          </form>
        )}

        {/* ── Fallback ── */}
        {!isRedeemNowOnly && !isCashbackForm && (
          <p className="text-center text-gray-500 text-sm py-4">
            This QR is not valid for redemption.
          </p>
        )}
      </div>
    </div>
  );
};

export default QRFormPage;